import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export enum UserNotReadyReason {
  None = 'None',
  PresenceUnknown = 'PresenceUnknown',
  PresenceOffline = 'PresenceOffline',
  PresenceAppearOffline = 'PresenceAppearOffline',
  PresenceAway = 'PresenceAway',
  PresenceBeRightBack = 'PresenceBeRightBack',
  PresenceBusy = 'PresenceBusy',
  PresenceBusyInACall = 'PresenceBusyInACall',
  PresenceBusyInAMeeting = 'PresenceBusyInAMeeting',
  PresenceDoNotDisturb = 'PresenceDoNotDisturb',
  TaskStateOnATask = 'TaskStateOnATask',
  TaskStateOnATaskBlocking = 'TaskStateOnATaskBlocking',
  TaskStateInRona = 'TaskStateInRona',
  TaskStateInACW = 'TaskStateInACW',
  TaskStateInExtendedACW = 'TaskStateInExtendedACW',
  TaskStateTaskLimitReached = 'TaskStateTaskLimitReached',
  DutyStateEmpty = 'DutyStateEmpty',
  DutyStateInactive = 'DutyStateInactive',
  DutyStateOffDuty = 'DutyStateOffDuty',
  DutyStateOffDutyAndInactive = 'DutyStateOffDutyAndInactive',
}

export const UserNotReadyReasonTooltipMapper: Record<UserNotReadyReason, TranslationKeys> = {
  [UserNotReadyReason.None]: TranslationKeys.UserNotReadyReasonNone,
  [UserNotReadyReason.PresenceUnknown]: TranslationKeys.UserNotReadyReasonPresenceUnknown,
  [UserNotReadyReason.PresenceOffline]: TranslationKeys.UserNotReadyReasonPresenceOffline,
  [UserNotReadyReason.PresenceAppearOffline]: TranslationKeys.UserNotReadyReasonPresenceAppearOffline,
  [UserNotReadyReason.PresenceAway]: TranslationKeys.UserNotReadyReasonPresenceAway,
  [UserNotReadyReason.PresenceBeRightBack]: TranslationKeys.UserNotReadyReasonPresenceBeRightBack,
  [UserNotReadyReason.PresenceBusy]: TranslationKeys.UserNotReadyReasonPresenceBusy,
  [UserNotReadyReason.PresenceBusyInACall]: TranslationKeys.UserNotReadyReasonPresenceBusyInACall,
  [UserNotReadyReason.PresenceBusyInAMeeting]: TranslationKeys.UserNotReadyReasonPresenceBusyInAMeeting,
  [UserNotReadyReason.PresenceDoNotDisturb]: TranslationKeys.UserNotReadyReasonPresenceDoNotDisturb,
  [UserNotReadyReason.TaskStateOnATask]: TranslationKeys.UserNotReadyReasonTaskStateOnATask,
  [UserNotReadyReason.TaskStateOnATaskBlocking]: TranslationKeys.UserNotReadyReasonTaskStateOnATaskBlocking,
  [UserNotReadyReason.TaskStateInRona]: TranslationKeys.UserNotReadyReasonTaskStateInRona,
  [UserNotReadyReason.TaskStateInACW]: TranslationKeys.UserNotReadyReasonTaskStateInACW,
  [UserNotReadyReason.TaskStateInExtendedACW]: TranslationKeys.UserNotReadyReasonTaskStateInExtendedACW,
  [UserNotReadyReason.TaskStateTaskLimitReached]: TranslationKeys.UserNotReadyReasonTaskStateTaskLimitReached,
  [UserNotReadyReason.DutyStateEmpty]: TranslationKeys.UserNotReadyReasonDutyStateEmpty,
  [UserNotReadyReason.DutyStateInactive]: TranslationKeys.UserNotReadyReasonDutyStateInactive,
  [UserNotReadyReason.DutyStateOffDuty]: TranslationKeys.UserNotReadyReasonDutyStateOffDuty,
  [UserNotReadyReason.DutyStateOffDutyAndInactive]: TranslationKeys.UserNotReadyReasonDutyStateOffDutyAndInactive,
};
